









































































































import { Component, Prop } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import { BusEvent } from '@/models/bus';

import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import ListLesson from '@/components/listView/ListLesson.vue';
import EditSubmodule from '@/editComponents/EditSubmodule.vue';
import EditLesson from '@/editComponents/EditLesson.vue';
import MassImport from '@/components/MassImport.vue';
import Program from '@/api/program';
import ContentCheck from '@/components/ContentCheck.vue';

@Component({
  components: {
    'list-lesson': ListLesson,
    'edit-submodule': EditSubmodule,
    'edit-lesson': EditLesson,
    'arrow-icon': ArrowIcon,
    'mass-import': MassImport,
    'content-check': ContentCheck
  }
})
export default class LessonView extends CommonVue {
  @Prop({ type: String }) public entity!: string;
  @Prop({ type: Number }) public programId!: number;
  @Prop() public id?: number;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public program: Program = null;
  public showImport: boolean = false;
  public file: File | null = null;
  public contentCheck: boolean = false;

  public async beforeMount() {
    this.loadModule();
  }

  public async loadModule(): Promise<void> {
    this.busy = true;
    try {
      this.program = await Program.get(this.programId);
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get program information', e);
    } finally {
      this.busy = false;
    }
  }
}
